import ReactTable, { ReactTableDefaults } from "react-table-6";
import React, { Fragment, useState, useEffect } from "react";
import { notify } from "react-notify-toast";
import SwitchMenuBar from "../../../Components/SwitchMenuBar/SwitchMenuBar";
import "../../Bookings2/JobList.css";
import AdminWrapper from "../AdminWrapper";
import { API } from "../../../API";
import FormDropdown from "../../../Components/FormField/FormDropdown";
import "./allocation.css";
import FormDatePicker from "../../../Components/FormField/FormDatePicker";
import CheckableButton from "../../../Components/CheckableButton/CheckableButton";
import { cancellationReasons } from "../../Bookings2/Helper";
import { teacherResponse, teacherStatus, getClass } from "../../../Helper";
import CancelBookingPopupAdmin from "../../../Components/BookingCard/CancelBookingPopupAdmin";
import Modal from "../../../Components/Modal/Modal";
import { dateToISO } from "../../../Helper";
import { addDays } from "date-fns";

// const Moment = require('moment')
// const MomentRange = require('moment-range')
// const moment = MomentRange.extendMoment(Moment)

import Moment from "react-moment";
import "moment-timezone";
import moment from "moment/moment";

const EventSplitType = {
  NoSplit: "no_split",
  SplitInto2Events: "split_2_events",
  SplitInto3Events: "split_3_events",
};

const BookingSortedBy = {
  Date: "BookingDate",
  TeacherAllocated: "TeacherAllocated",
  TeacherUnAllocated: "TeacherUnAllocated",
  SingleDate: "SingleDate",
  DateRange: "DateRange",
};

const bookingDict = {};
const campusDict = {};
let datalist = [];
let testBookingDatalist = []
const classList = getClass();

const AllocationTablePage = () => {
  let [isAllBookinngsLoaded, setAllBookinngsLoaded] = useState(false);
  let [allUsers, setAllUsers] = useState([]);
  let [allCampus, setAllCampus] = useState([]);
  let [allInst, setAllInst] = useState([]);
  let [allClass, setAllClass] = useState([]);
  let [allInstUsers, setAllInstUsers] = useState([]);
  let [data, setData] = useState(datalist);
  // let [eventSplitTypes, setEventSplitTypes] = useState({});
  let [currentSplitEventByBooking, setCurrentSplitEventByBooking] = useState({})
  let [numberOfSplitEvent, setNumberOfSplitEvent] = useState(0)
  let [showCreatedTime, setShowCreatedTime] = useState(false);
  let [showCampus, setShowCampus] = useState(false);
  let [show25kms, setShow25kms] = useState(false);
  let [showFav, setShowFav] = useState(false);
  let [showAvail, setShowAvail] = useState(false);
  let [showArrival, setShowArrival] = useState(false);
  let [showTeachingHours, setShowTeachingHours] = useState(false);
  let [showNonTeachingHours, setShowNonTeachingHours] = useState(false);
  let [showLastTeacher, setShowLastTeacher] = useState(false);
  let [showUpdateLevel, setShowUpdateLevel] = useState(false);
  let [updatedLevel, setUpdatedLevel] = useState("");
  let [showTestBookings, setShowTestBookings] = useState(false);
  let [currentResplitBooking, setCurrentResplitBooking] = useState({})


  useEffect(() => {
    getAllUsers();
    getAllInstUsers();
    getAllInst();
    getAllCampus();
    getAllClass();
  }, []);

  useEffect(() => {
    if (
      allUsers.length > 0 &&
      allCampus.length > 0 &&
      allInst.length > 0 &&
      allInstUsers.length > 0
    ) {
      getAllBookingsOfUser();
    }
  }, [allCampus, allInst, allUsers, allInstUsers]);

  const getAllUsers = async () => {
    try {
      await API.allTeachersForAllocate()
        .then(function (result) {
          let users = result.data
            .filter((user) => {
              return user.first_name || user.last_name;
            })
            .sort((a, b) => {
              let nameA = (a.first_name + " " + a.last_name).toLowerCase();
              let nameB = (b.first_name + " " + b.last_name).toLowerCase();
              return nameA > nameB ? 1 : -1;
            });
          // console.log(users.map(user => user.first_name + " " + user.last_name))
          setAllUsers(users);
        })
        .catch(function (err) {
          console.log(err);
        });
    } catch (error) {
      alert(error);
    }
  };

  const getAllInstUsers = async () => {
    try {
      await API.allInstUsersForAllocate()
        .then((result) => {
          setAllInstUsers(result.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      alert(error);
    }
  };

  const getAllBookingsOfUser = async () => {
    try {
      API.getAllBookings()
        .then(function (result) {
          setAllBookinngsLoaded(true);
          groupBookingsBasedOnId(result.data);
          convertBookings(result.data);
        })
        .catch(function (err) {
          console.log("getAllBookingsOfUser error", err);
        });
    } catch (error) {
      alert(error);
    }
  };

  const getAllCampus = async () => {
    try {
      API.getAllCampusWithCache()
        .then(function (result) {
          setAllCampus(result.data);
        })
        .catch(function (err) {
          console.log(err);
        });
    } catch (error) {
      alert(error);
    }
  };

  const getAllInst = async () => {
    try {
      API.getAllInstWithCache()
        .then(function (result) {
          setAllInst(result.data);
        })
        .catch(function (err) {
          console.log(err);
        });
    } catch (error) {
      alert(error);
    }
  };

  const getAllClass = async () => {
    try {
      API.getAllClasses()
        .then(function (result) {
          setAllClass(result.data);
        })
        .catch(function (err) {
          console.log(err);
        });
    } catch (error) {
      alert(error);
    }
  };

  const getFullName = (key) => {
    if (key) {
      let object = classList.find((item) => {
        return item.key === key;
      });
      if (object) {
        return object.whole_name;
      } else {
        return "";
      }
    } else {
      return "";
    }
  };

  const convertBookings = (bookings) => {
    datalist = [];
    // console.log("Bookings", bookings);
    if (bookings) {
      console.time("convertBooking")
      bookings.forEach((item) => {
        let campus = campusDict[item.campus_id] || null;
        if (campus === null) {
          campus = allCampus.find((el) => el._id === item.campus_id);
          campusDict[item.campus_id] = campus;
        }

        let inst = null;
        if (campus) {
          inst = allInst.find((el) => el._id === campus.institution_id);
        }

        let maker = item.booking_maker
          ? allInstUsers.find((el) => el._id === item.booking_maker)
          : null;
        let makername = maker
          ? maker.first_name
            ? `${maker.first_name} ${maker.last_name.charAt(0)}` + "."
            : `${maker.personnel_first_name} ${maker.personnel_last_name.charAt(0)}` + "."
          : "";

        let preferred_teacher = item.preferred_teacher
          ? allUsers.find((el) => el._id === item.preferred_teacher)
          : null;
        let pref_tea_name = preferred_teacher
          ? `${preferred_teacher.first_name} ${preferred_teacher.last_name}`
          : "None";

        let institution = inst ? inst.institution_name : "Inst not found";
        let campus_city = campus ? campus.suburb : "Campus not found";
        let last_allocate = getLastBookingTeacherAllocation(
          item.campus_id,
          item.end_booking_date
        );
        last_allocate = last_allocate.map(item => {
          if(item) {
            const fullName = item.replace(/\s+/g, " ").split(" ");
            return fullName.shift() + " " + fullName.pop().charAt(0).toUpperCase() + "."
          }
          return item
        })
        // for (let i = 0; i < last_allocate.length; i++) {
        //   if (last_allocate[i]) {
        //     const fullName = last_allocate[i].replace(/\s+/g, " ").split(" ");
        //     last_allocate[i] = fullName.shift() + " " + fullName.pop().charAt(0).toUpperCase() + "."
        //   }
        // }
        last_allocate = last_allocate.join(", ")
        let level = getFullName(item.level);
        let deliveryMode =
          item.online ?
            item.deliver_from_home === undefined ? "Online"
              :
              (item.deliver_from_home ? "Online - Deliver from home" : "Online - Deliver on-campus")
            :
            "On Campus"
        let start_date = item.booking_date;
        let start_date_array = start_date ? start_date.split("-") : [0, 0, 0];
        let start_date_au = `${start_date_array[2]}/${start_date_array[1]}/${start_date_array[0]}`;
        let end_date = item.end_booking_date;
        let end_date_array = end_date ? end_date.split("-") : [0, 0, 0];
        let end_date_au = `${end_date_array[2]}/${end_date_array[1]}/${end_date_array[0]}`;
        let split_start_date = start_date;
        let split_end_date =
          item.multiple_date && item.splits && item.splits.length > 0
            ? item.splits[0].date_to
            : end_date;
        let days_of_delivery = item.days_of_delivery
          ? item.days_of_delivery
          : "";
        let unavailable_teacher = item.unavailable_teacher ? item.unavailable_teacher : false;

        const startDate = new Date(start_date)
        const endDate = new Date(end_date);
        endDate.setDate(endDate.getDate() + 1);
        const daysOfWeekInRange = [];
        let i = 0;
        while (i < 7 && startDate < endDate) {
          daysOfWeekInRange.push(startDate.toLocaleString('en-us', {  weekday: 'long' }));
          startDate.setDate(startDate.getDate() + 1);
          i++;
        }

        let lessons =
          item.dates && item.dates.length > 0 ? item.dates.length : 1;
        let arrival = item.arrival_time;
        let start = item.start_time;
        let end = item.end_time;
        let teaching_hour = item.paid_teaching_hours;
        let non_teaching_mins = item.paid_nonteaching_mins
            ? item.non_teach_calculation === 'daily'
              ? item.paid_nonteaching_mins + ' mins/day'
              : item.non_teach_calculation === 'weekly'
                ? item.paid_nonteaching_mins + ' mins/week'
                : item.non_teach_calculation === 'monthly'
                  ? item.paid_nonteaching_mins + ' mins/month' : 0
            : 0
        let total_teaching_hour = teaching_hour * (item.multiple_date ? item.dates.length : 1);
        /*
        let non_teaching_hour = item.paid_nonteaching_mins
          ? item.non_teach_calculation === "weekly"
            ? item.paid_nonteaching_mins /
              60 /
              days_of_delivery.replace(/^,/, "").split(",").length
            : (item.paid_nonteaching_mins / 60).toFixed(1)
          : item.paid_nonteaching_hours
          ? item.paid_nonteaching_hours
          : 0;
        let total_hour = teaching_hour + parseFloat(non_teaching_hour);
        let whole_booking =
          total_hour * (item.multiple_date ? item.dates.length : 1);
        */
        days_of_delivery = days_of_delivery.replace(/^,/, "").split(",").filter(value => daysOfWeekInRange.includes(value));
        let status = item.multiple_date
          ? !item.splits || item.splits.length === 0
            ? item.cancelled_by_inst
              ? "cancelled by inst"
              : item.teacher_status
              ? item.teacher_status === teacherStatus.responded
                ? item.teacher_response
                : item.teacher_status
              : teacherStatus.not_assigned
            : item.splits[0].cancelled_by_inst
            ? "cancelled by inst"
            : item.splits[0].teacher_status === teacherStatus.responded
            ? item.splits[0].teacher_response
            : item.splits[0].teacher_status
          : item.cancelled_by_inst
            ? "cancelled by inst"
            : item.teacher_status === teacherStatus.responded
              ? item.teacher_response
              : item.unavailable_teacher ? teacherStatus.none_available : item.teacher_status;
        let teacher = item.multiple_date
          ? !item.splits || item.splits.length === 0
            ? item.teacher_id
              ? allUsers.find((el) => {
                  return el._id === item.teacher_id;
                })
              : null
            : item.splits[0].teacher_id
            ? allUsers.find((el) => {
                return el._id === item.splits[0].teacher_id;
              })
            : null
          : item.teacher_id
          ? allUsers.find((el) => {
              return el._id === item.teacher_id;
            })
          : null;
        let teachername = teacher
          ? `${teacher.first_name} ${teacher.last_name}`
          : "";
        let fav_teacher_list = inst ? inst.fav_teacher_list : [];
        let teacher_status = item.multiple_date
          ? !item.splits || item.splits.length === 0
            ? item.teacher_status
              ? item.teacher_status
              : teacherStatus.not_assigned
            : item.splits[0].teacher_status
          : item.teacher_status;
        let teacher_response = item.multiple_date
          ? !item.splits || item.splits.length === 0
            ? item.teacher_response
              ? item.teacher_response
              : teacherResponse.not_responded
            : item.splits[0].teacher_response
          : item.teacher_response;
        let payment_status = item.multiple_date
          ? !item.splits || item.splits.length === 0
            ? item.payment_status
              ? item.payment_status
              : ""
            : item.splits[0].payment_status
          : item.payment_status
          ? item.payment_status
          : "";
        let teacher_cancel_reason = item.multiple_date
          ? !item.splits || item.splits.length === 0
            ? item.teacher_cancel_reason || ""
            : item.splits[0].teacher_cancel_reason || ""
          : item.teacher_cancel_reason || "";

        let previous_teacher_allocation = item.multiple_date
          ? !item.splits || item.splits.length === 0
            ? item.previous_teacher_allocation || ""
            : item.splits[0].previous_teacher_allocation || ""
          : item.previous_teacher_allocation || "";

        let canceledTime = item.multiple_date && item.splits.length
          ? item.splits?.find(ele => ele.date_from === split_start_date && ele.date_to === split_end_date)?.cancelled_time
          : item?.cancelled_time

        let inst_cancel_reason = item.multiple_date && item.splits.length
          ? item.splits?.find(ele => ele.date_from === split_start_date && ele.date_to === split_end_date)?.inst_cancelled_reason
          : item?.inst_cancelled_reason
        
        let canceledBy = item.multiple_date && item.splits.length
          ? item.splits?.find(ele => ele.date_from === split_start_date && ele.date_to === split_end_date)?.cancelled_by
          : item?.cancelled_by

        let last_status_before_cancel = item.multiple_date && item.splits.length
        ? item.splits?.find(ele => ele.date_from === split_start_date && ele.date_to === split_end_date)?.last_status_before_cancel
        : item?.last_status_before_cancel

        // ================ Any extra fields here for the customized cells

        // unsed eventSplitTypes any more from Aug, 2022 but just keep for backup
        // if (!item.multiple_date || !item.splits || item.splits.length < 2) {
        //   eventSplitTypes[item._id] = EventSplitType.NoSplit;
        // } else if (item.splits.length === 2) {
        //   eventSplitTypes[item._id] = EventSplitType.SplitInto2Events;
        // } else {
        //   eventSplitTypes[item._id] = EventSplitType.SplitInto3Events;
        // }

        if(item.splits.length) {
          currentSplitEventByBooking = {
            ...currentSplitEventByBooking,
            [item._id]: item.splits.length
          }
        }

        let job = {
          id: item._id,
          campus_id: item.campus_id,
          class_id: item.class_id,
          multiple_date: item.multiple_date,
          all_dates: item.dates,
          dates: item.dates,
          splits: item.splits,
          institution,
          deliveryMode,
          makername,
          campus_city,
          last_allocate,
          level,
          start_date,
          start_date_au,
          end_date,
          end_date_au,
          split_start_date,
          split_end_date,
          days_of_delivery,
          lessons,
          arrival,
          start,
          end,
          teaching_hour,
          non_teaching_mins,
          total_teaching_hour,
          // non_teaching_hour,
          // total_hour,
          // whole_booking,
          status,
          teacher_status,
          teacher_response,
          payment_status,
          teachername,
          teacher,
          teachers: allUsers,
          fav_teacher_list,
          check_fav: false,
          check_ava: false,
          check_25km: false,
          split_index: 0,
          preferred_teacher,
          pref_tea_name,
          toConfirm: false,
          teacher_cancel_reason,
          inst_cancel_reason: inst_cancel_reason,
          created: item.createdAt,
          previous_teacher_allocation,
          unavailable_teacher,
          cancelled_by: canceledBy,
          cancelled_time: canceledTime,
          last_status_before_cancel: last_status_before_cancel
        };
        if (job.makername === "ReadyTeacher T." || job.institution === "ReadyTeacherTest") {
          testBookingDatalist.push(job);
        } else {
          datalist.push(job);
        }

        if (item.splits && item.splits.length > 1) {
          // console.log("splits", item.splits)
          for (let i = 1; i < item.splits.length; i++) {
            let subsplit_start_date = item.splits[i].date_from;
            let subsplit_end_date = item.splits[i].date_to;

            let substatus = item.splits[i].cancelled_by_inst
              ? "cancelled by inst"
              : item.splits[i].teacher_status === teacherStatus.responded
              ? item.splits[i].teacher_response
              : item.splits[i].teacher_status;

            let subteacher_status = item.splits[i].teacher_status;
            let subteacher_response = item.splits[i].teacher_response;
            let subpayment_status = item.splits[i].payment_status;

            let subteacher = item.splits[i].teacher_id
              ? allUsers.find((el) => {
                  return el._id === item.splits[i].teacher_id;
                })
              : null;

            let subteachername = subteacher
              ? `${subteacher.first_name} ${subteacher.last_name}`
              : "";

            let subdates = item.dates.filter((date) => {
              return date.date > subsplit_start_date;
            });

            let subcancelreason = item.splits[i].teacher_cancel_reason || "";
            let subinstcancelreason = item.splits[i].inst_cancelled_reason || "";

            let sub_previous_teacher_allocation =
              item.splits[i].previous_teacher_allocation || "";

            let sub_unavailable_teacher = item.splits[i].unavailable_teacher || false

            let subjob = {
              id: item._id,
              multiple_date: item.multiple_date,
              all_dates: item.dates,
              dates: subdates,
              splits: item.splits,
              split_start_date: subsplit_start_date,
              split_end_date: subsplit_end_date,
              status: substatus,
              teacher_status: subteacher_status,
              teacher_response: subteacher_response,
              payment_status: subpayment_status,
              teachername: subteachername,
              teacher: subteacher,
              teachers: allUsers,
              fav_teacher_list,
              check_fav: job.check_fav,
              check_ava: job.check_ava,
              check_25km: job.check_25km,
              split_index: i,
              preferred_teacher,
              pref_tea_name,
              toConfirm: false,
              is_subjob: true,
              created: job.created,
              institution: job.institution,
              makername: job.makername,
              campus_city: job.campus_city,
              deliveryMode: job.deliveryMode,
              last_allocate: job.last_allocate,
              level: job.level,
              start_date: job.start_date,
              end_date: job.end_date,
              days_of_delivery: job.days_of_delivery,
              lessons: job.lessons,
              arrival: job.arrival,
              start: job.start,
              end: job.end,
              teaching_hour: job.teaching_hour,
              non_teaching_mins: job.non_teaching_mins,
              total_teaching_hour: job.total_teaching_hour,
              // non_teaching_hour: job.non_teaching_hour,
              // total_hour: job.total_hour,
              // whole_booking: job.whole_booking,
              teacher_cancel_reason: subcancelreason,
              inst_cancel_reason: subinstcancelreason,
              previous_teacher_allocation: sub_previous_teacher_allocation,
              unavailable_teacher: sub_unavailable_teacher,
              cancelled_by: item.splits[i].cancelled_by,
              cancelled_time: item.splits[i].cancelled_time,
              last_status_before_cancel: item.splits[i].last_status_before_cancel
            };
            if (subjob.makername === "ReadyTeacher T." || subjob.institution === "ReadyTeacherTest") {
              testBookingDatalist.push(subjob);
            } else {
              datalist.push(subjob);
            }
          }
        }
      });
      console.timeEnd("convertBooking")
    }

    setData(datalist);
  };

  const checkboxCell = ({
    value,
    original,
    columnProps: {
      rest: { func, label },
    },
  }) => {
    const flip = () => {
      if (func) {
        func(label, original.id);
      }
    };

    return <input type="checkbox" checked={value} onClick={flip} />;
  };

  const flipfilter = (label, id) => {
    let newData = data.map((item) => {
      if (item.id === id) {
        item[label] = !item[label];
        let teachers = [...allUsers];
        if (item.check_fav && item.fav_teacher_list)
          teachers = filterFavorite(item.fav_teacher_list, teachers);
        // if (item.check_ava)
        // if (item.check_25km)
        item.teachers = teachers;
      }
      return item;
    });
    setData(newData);
  };

  const onTeacherAllocationChanged = (e, original) => {
    const { id, split_index } = original;
    let newData = [...data];
    const foundBooking = newData.find(
      (el) => el.id === id && el.split_index === split_index
    );
    if (foundBooking) {
      foundBooking.teacher = allUsers.find((el) => el._id === e.target.value);
      foundBooking.teachername = queryTeacherName(e.target.value);
      foundBooking.teacher_status = teacherStatus.assigned;
      foundBooking.teacher_response = teacherResponse.not_responded;
      foundBooking.teacher_cancel_reason = "";
    }
    setData(newData);
  };

  const dropdownCell = ({ original }) => {
    const teachers = original.teachers;
    const allocated = hasAllocatedStatusForCurrentEvent(original);
    const noneAvailable = checkBookingNoneAvailable(original)
    // console.log(original.teacher)
    return (
      <FormDropdown
        className="mr-2"
        disabled={allocated || noneAvailable}
        value={original.teacher ? original.teacher._id : ""}
        onChange={(evt) => onTeacherAllocationChanged(evt, original)}
      >
        {/* {original.teachername ? (
          <option> {original.teachername} </option>
        ) : null} */}
        <option> None </option>
        {teachers
          ? teachers.map((teacher) => {
              return (
                <option value={teacher._id} key={teacher._id}>
                  {teacher.first_name} {teacher.preferred_name && teacher.preferred_name !== teacher.first_name ? ' \'' + teacher.preferred_name.trim() + '\'' : null} {teacher.last_name}
                </option>
              );
            })
          : null}
      </FormDropdown>
    );
  };

  const filterFavorite = (fav_list, teachers) => {
    return teachers.filter((teacher) => {
      return fav_list.indexOf(teacher._id) > -1;
    });
  };

  const dateRangeCell = ({ original }) => {
    let {
      start_date_au,
      end_date_au,
      split_start_date,
      split_end_date,
      multiple_date,
      split_index,
      id,
      dates,
    } = original;
    let splits_length = numberOfSplitEvent
      // eventSplitTypes[id] === EventSplitType.NoSplit
      //   ? 1
      //   : eventSplitTypes[id] === EventSplitType.SplitInto2Events
      //   ? 2
      //   : 3;
      let datesToSelect = [...dates]
      if(splits_length > 1) {
        // console.log("datesToSelect: ", datesToSelect)
        datesToSelect = dates.slice(0, dates.length - numberOfSplitEvent + split_index + 1)
        datesToSelect = datesToSelect.filter(date => date?.date >= split_start_date)
      }
    if (multiple_date) {
      if (split_index === splits_length - 1 || splits_length === 0) {
        return (
          <>
            <p> From: {changeToAuDate(split_start_date)} </p>
            <p> To: {changeToAuDate(split_end_date)} </p>
          </>
        );
      } else {
        return (
          <>
            <p> From: {changeToAuDate(split_start_date)} </p>
            {/* <p> */} To:
            <FormDropdown
              // selected={original.split_end_date ? original.split_end_date : ""}
              onChange={(e) => onDateChange(e, id, split_index)}
            >
              {original.split_end_date ? (
                <option value={original.split_end_date} key={original.split_end_date} selected> {changeToAuDate(original.split_end_date)} </option>
              ) : (
                <option value={datesToSelect[0].date} key={datesToSelect[0].date} selected> {changeToAuDate(datesToSelect[0].date)} </option>
              )}
              {/* <option> None </option> */}
              {datesToSelect
                ? datesToSelect.map((date) => {
                    return (
                      <option value={date.date} key={date.date} selected={date.date === original.split_end_date}>
                        {changeToAuDate(date.date)}
                      </option>
                    );
                  })
                : null}
            </FormDropdown>
            {/* </p> */}
          </>
        );
      }
    } else {
      return <p> On: {start_date_au} </p>;
    }
  };

  const changeToAuDate = (date) => {
    let dates = date.split("-");
    return `${dates[2]}/${dates[1]}/${dates[0]}`;
  };

  const onDateChange = (e, id, split_index) => {
    let splits_length = numberOfSplitEvent
      // eventSplitTypes[id] === EventSplitType.NoSplit
      //   ? 1
      //   : eventSplitTypes[id] === EventSplitType.SplitInto2Events
      //   ? 2
      //   : 3;
    let end_date = e.target.value;
    if (split_index < splits_length - 1) {
      let newData = [...data];
      for(let i = 0; i < newData.length; i++) {
        let item = newData[i]
        if (item.id === id) {
          if (item.split_index === split_index) {
            item.split_end_date = end_date;
          } 
          // else if (item.split_index === split_index + 1) {
          //   let newDates = item.all_dates.filter((date) => {
          //     return date.date > end_date;
          //   });
          //   let new_split_start_date =
          //     newDates && newDates.length > 0 ? newDates[0].date : "error";
          //   let new_split_end_date =
          //     new_split_start_date === "error"
          //       ? "error"
          //       : new_split_start_date
          //   console.log("new_split_start_date: ", new_split_start_date, new_split_end_date)
            
          //   item.split_start_date = new_split_start_date;
          //   item.split_end_date = new_split_start_date;
          //   // item.dates = newDates;
          // }
          else if (item.split_index > split_index){
            let newDates = item.all_dates.filter((date) => {
              return date.date > end_date;
            });
            // item.split_start_date = newDates[item.split_index - split_index]?.date
            item.split_start_date = newDates[item.split_index - split_index - 1]?.date
            item.split_end_date = newDates[item.split_index - split_index - 1]?.date
            if(item.split_index === numberOfSplitEvent - 1) {
              // console.log("last: ", item.split_index - 1, newData[item.split_index - 1])
              // item.split_start_date = newDates[item.split_index - split_index - 1]?.date
              item.split_end_date = newDates[newDates.length - 1]?.date
            }
            else {
              item.split_end_date = newDates[item.split_index - split_index - 1]?.date
            }
          }
        }
        newData[i] = item
      };
      setData(newData);
    }
  };

  const queryInstitutionId = (campus_id) => {
    let result = null;
    const campus = allCampus.find((el) => el._id == campus_id);
    if (campus) {
      result = campus.institution_id;
    }

    return result;
  };

  const queryTeacherName = (teacher_id) => {
    const foundTeacher = allUsers.find((item) => item._id === teacher_id);
    return foundTeacher
      ? foundTeacher.first_name + " " + foundTeacher.last_name
      : "";
  };

  const getLastBookingTeacherAllocation = (campus_id, end_booking_date) => {
    const assignedTeacherDict = {};
    const instId = queryInstitutionId(campus_id);

    const bookingList = bookingDict[instId] || null;
    if (bookingList) {
      let currentTime = new Date(end_booking_date).getTime();
      const lastBooking = bookingList.find((item) => {
        let comparedTime = new Date(item.end_booking_date).getTime();
        return comparedTime < currentTime;
      });

      if (lastBooking) {
        if (lastBooking.splits.length > 0) {
          lastBooking.splits.forEach((spl) => {
            if (spl.teacher_id && !assignedTeacherDict[spl.teacher_id]) {
              assignedTeacherDict[spl.teacher_id] = queryTeacherName(
                spl.teacher_id
              );
            }
          });
        } else {
          if (
            lastBooking.teacher_id &&
            !assignedTeacherDict[lastBooking.teacher_id]
          ) {
            assignedTeacherDict[lastBooking.teacher_id] = queryTeacherName(
              lastBooking.teacher_id
            );
          }
        }
      }
    }

    return Object.values(assignedTeacherDict);
  };

  const groupBookingsBasedOnId = (allBookings) => {
    if (allBookings) {
      allBookings.forEach((item) => {
        let campus = campusDict[item.campus_id] || null;
        if (campus == null) {
          campus = allCampus.find((el) => el._id == item.campus_id);
          campusDict[item.campus_id] = campus;
        }

        if (campus != null) {
          let bookings = bookingDict[campus.institution_id] || null;
          if (bookings == null) {
            bookings = [];
            bookingDict[campus.institution_id] = bookings;
          }

          bookings.push(item);
        }
      });
    }
  };

  const buildSubEventObject = (
    id,
    rowIndex,
    split_index,
    data,
    start,
    end,
    dates
  ) => {
    if (split_index != 0) {
      const subItem = {
        id: id,
        multiple_date: data[rowIndex].multiple_date,
        splits: data[rowIndex].splits,
        status: teacherStatus.not_assigned,
        teacher_status: teacherStatus.not_assigned,
        teacher_response: teacherResponse.not_responded,
        payment_status: "",
        teachername: "",
        teachers: data[rowIndex].teachers,
        fav_teacher_list: data[rowIndex].fav_teacher_list,
        check_fav: data[rowIndex].check_fav,
        check_ava: data[rowIndex].check_ava,
        check_25km: data[rowIndex].check_25km,
        split_index: split_index,
        preferred_teacher: data[rowIndex].preferred_teacher,
        pref_tea_name: data[rowIndex].pref_tea_name,
        split_start_date: start,
        split_end_date: end,
        dates,
        all_dates: data[rowIndex].all_dates,
        created: data[rowIndex].created,
        institution: data[rowIndex].institution,
        level: data[rowIndex].level,
        start: data[rowIndex].start,
        end: data[rowIndex].end,
        arrival: data[rowIndex].arrival,
        days_of_delivery: data[rowIndex].days_of_delivery,
        deliveryMode: data[rowIndex].deliveryMode,
        total_teaching_hour: data[rowIndex].total_teaching_hour,
        filter_last_allocate: data[rowIndex].last_allocate,
        filter_start_date_au: data[rowIndex].start_date_au,
        filter_end_date_au: data[rowIndex].end_date_au,
        filter_start_date: data[rowIndex].start_date,
        filter_end_date: data[rowIndex].end_date,
        filter_lessons: data[rowIndex].lessons,
        makername: data[rowIndex].makername
      }
      return subItem;
    } else {
      let item = data[rowIndex];
      item.status = teacherStatus.not_assigned;
      item.teacher_status = teacherStatus.not_assigned;
      item.teacher_response = teacherResponse.not_responded;
      item.payment_status = "";
      item.teachername = "";
      item.split_start_date = start;
      item.split_end_date = end;
      item.dates = dates;

      return item;
    }
  };

  // const splitCheckBoxesValueChanged = (id, rowIndex, event) => {
  //   const oldSplitType = eventSplitTypes[id];

  //   const newEventTypes = { ...eventSplitTypes };
  //   newEventTypes[id] = event.target.value;
  //   setEventSplitTypes(newEventTypes);

  //   let all_dates = data[rowIndex].all_dates;
  //   if (rowIndex >= 0) {
  //     let newData = [...data];
  //     switch (event.target.value) {
  //       case EventSplitType.NoSplit:
  //         let start_0 = all_dates[0].date;
  //         let end_0 = all_dates[all_dates.length - 1].date;
  //         let dates_0 = [];
  //         newData.splice(
  //           rowIndex,
  //           1,
  //           buildSubEventObject(id, rowIndex, 0, data, start_0, end_0, dates_0)
  //         );

  //         if (oldSplitType === EventSplitType.SplitInto2Events) {
  //           newData.splice(rowIndex + 1, 1);
  //         } else if (oldSplitType === EventSplitType.SplitInto3Events) {
  //           newData.splice(rowIndex + 1, 2);
  //         }
  //         break;
  //       case EventSplitType.SplitInto2Events:
  //         if(oldSplitType === EventSplitType.SplitInto3Events) {
  //           newData = newData.filter((item) => {
  //             return !(item?.split_index && item.splits.length <= 0)
  //           })
  //         }
          
  //         let s2_start_0 = all_dates[0].date;
  //         let s2_end_0 = all_dates[0].date;
  //         let s2_dates_0 = all_dates;
  //         let s2_start_1 = all_dates[1].date;
  //         let s2_end_1 = all_dates[all_dates.length - 1].date;
  //         let s2_dates_1 = [];

  //         newData.splice( rowIndex, 1,
  //           buildSubEventObject(
  //             id,
  //             rowIndex,
  //             0,
  //             data,
  //             s2_start_0,
  //             s2_end_0,
  //             s2_dates_0
  //           )
  //         );

  //         newData.splice( rowIndex + 1, 0,
  //           buildSubEventObject(
  //             id,
  //             rowIndex,
  //             1,
  //             data,
  //             s2_start_1,
  //             s2_end_1,
  //             s2_dates_1
  //           )
  //         );
  //         break;
  //       case EventSplitType.SplitInto3Events:
  //         if(oldSplitType === EventSplitType.SplitInto2Events) {
  //           newData = newData.filter((item) => {
  //             return !(item?.split_index && item.splits.length <= 0)
  //           })
  //         }
  //         let s3_start_0 = all_dates[0].date;
  //         let s3_end_0 = all_dates[0].date;
  //         let s3_dates_0 = all_dates;
  //         let s3_start_1 = all_dates[1].date;
  //         let s3_end_1 = all_dates[1].date;
  //         let s3_dates_1 = all_dates.filter((_, index) => index > 0);
  //         let s3_start_2 = all_dates[2].date;
  //         let s3_end_2 = all_dates[all_dates.length - 1].date;
  //         let s3_dates_2 = [];

  //         newData.splice(
  //           rowIndex,
  //           1,
  //           buildSubEventObject(
  //             id,
  //             rowIndex,
  //             0,
  //             data,
  //             s3_start_0,
  //             s3_end_0,
  //             s3_dates_0
  //           )
  //         );

  //         newData.splice(
  //           rowIndex + 1,
  //           0,
  //           buildSubEventObject(
  //             id,
  //             rowIndex,
  //             1,
  //             data,
  //             s3_start_1,
  //             s3_end_1,
  //             s3_dates_1
  //           )
  //         );

  //         newData.splice(
  //           rowIndex + 2,
  //           0,
  //           buildSubEventObject(
  //             id,
  //             rowIndex,
  //             2,
  //             data,
  //             s3_start_2,
  //             s3_end_2,
  //             s3_dates_2
  //           )
  //         );
  //         break;
  //       default:
  //       // code block
  //     }
  //     console.log("sending data");
  //     setData(newData);
  //   }
  // };

  const splitBookingValueChange = (id, rowIndex, event) => {
    const numberOfEvents = +event.target.value
    let all_dates = data[rowIndex].all_dates;
    // validate numberOfEvents here - not yet
    if(numberOfEvents > all_dates.length) {
      notify.show("Number of events can't be greater than total day of booking");
      event.target.value = 1
      return;
    }

    // handling
    
    if (rowIndex >= 0) {
      setNumberOfSplitEvent(numberOfEvents)
      let newData = [...data];
      // console.log("currentSplitEventByBooking: ", data[rowIndex].id, numberOfEvents, currentSplitEventByBooking)
      if(currentSplitEventByBooking[data[rowIndex].id]) {
        // console.log("Should remove first")
        newData.splice(rowIndex + 1, currentSplitEventByBooking[data[rowIndex].id] - 1);
      }

      setCurrentSplitEventByBooking({
        ...currentSplitEventByBooking,
        [data[rowIndex].id]: +numberOfEvents
      })
      

      // console.log("currentSplitEventByBooking 2222: ", numberOfEvents, currentSplitEventByBooking)
      if(numberOfEvents === 0) {
        let start_date = all_dates[0].date
        let end_date = all_dates[all_dates?.length - 1]?.date
        let dates = all_dates.filter((_, index) => index > 1);
        newData.splice(
          rowIndex,
          1,
          buildSubEventObject(id, rowIndex, 0, data, start_date, end_date, dates)
        );
        newData.splice(rowIndex + 1, data[rowIndex].splits.length);
      }
      else {
        for(let i = 0; i < numberOfEvents; i++) {
          let start_date = all_dates[i].date
          let end_date = i === numberOfEvents - 1 ? all_dates[all_dates.length - 1].date : start_date
          let dates = i === 0 ? all_dates : all_dates.filter((_, index) => index > i);
          newData.splice(
            rowIndex + i,
            1 - i >= 0 ? 1-i : 0,
            buildSubEventObject(id, rowIndex, i, data, start_date, end_date, dates)
          );
        }
      }
      setData(newData);

      // switch (numberOfEvents) {
      //   case 0:
      //     let start_0 = all_dates[0].date;
      //     let end_0 = all_dates[all_dates.length - 1].date;
      //     let dates_0 = [];
      //     newData.splice(
      //       rowIndex,
      //       1,
      //       buildSubEventObject(id, rowIndex, 0, data, start_0, end_0, dates_0)
      //     );

      //     if (oldSplitType === EventSplitType.SplitInto2Events) {
      //       newData.splice(rowIndex + 1, 1);
      //     } else if (oldSplitType === EventSplitType.SplitInto3Events) {
      //       newData.splice(rowIndex + 1, 2);
      //     }
      //     break;
      //   case EventSplitType.SplitInto2Events:
      //     if(oldSplitType === EventSplitType.SplitInto3Events) {
      //       newData = newData.filter((item) => {
      //         return !(item?.split_index && item.splits.length <= 0)
      //       })
      //     }
          
      //     let s2_start_0 = all_dates[0].date;
      //     let s2_end_0 = all_dates[0].date;
      //     let s2_dates_0 = all_dates;
      //     let s2_start_1 = all_dates[1].date;
      //     let s2_end_1 = all_dates[all_dates.length - 1].date;
      //     let s2_dates_1 = [];

      //     newData.splice( rowIndex, 1,
      //       buildSubEventObject(
      //         id,
      //         rowIndex,
      //         0,
      //         data,
      //         s2_start_0,
      //         s2_end_0,
      //         s2_dates_0
      //       )
      //     );

      //     newData.splice( rowIndex + 1, 0,
      //       buildSubEventObject(
      //         id,
      //         rowIndex,
      //         1,
      //         data,
      //         s2_start_1,
      //         s2_end_1,
      //         s2_dates_1
      //       )
      //     );
      //     break;
      //   case EventSplitType.SplitInto3Events:
      //     if(oldSplitType === EventSplitType.SplitInto2Events) {
      //       newData = newData.filter((item) => {
      //         return !(item?.split_index && item.splits.length <= 0)
      //       })
      //     }
      //     let s3_start_0 = all_dates[0].date;
      //     let s3_end_0 = all_dates[0].date;
      //     let s3_dates_0 = all_dates;
      //     let s3_start_1 = all_dates[1].date;
      //     let s3_end_1 = all_dates[1].date;
      //     let s3_dates_1 = all_dates.filter((_, index) => index > 0);
      //     let s3_start_2 = all_dates[2].date;
      //     let s3_end_2 = all_dates[all_dates.length - 1].date;
      //     let s3_dates_2 = [];

      //     newData.splice(
      //       rowIndex,
      //       1,
      //       buildSubEventObject(
      //         id,
      //         rowIndex,
      //         0,
      //         data,
      //         s3_start_0,
      //         s3_end_0,
      //         s3_dates_0
      //       )
      //     );

      //     newData.splice(
      //       rowIndex + 1,
      //       0,
      //       buildSubEventObject(
      //         id,
      //         rowIndex,
      //         1,
      //         data,
      //         s3_start_1,
      //         s3_end_1,
      //         s3_dates_1
      //       )
      //     );

      //     newData.splice(
      //       rowIndex + 2,
      //       0,
      //       buildSubEventObject(
      //         id,
      //         rowIndex,
      //         2,
      //         data,
      //         s3_start_2,
      //         s3_end_2,
      //         s3_dates_2
      //       )
      //     );
      //     break;
      //   default:
      //   // code block
      // }
      // console.log("sending data");
      // setData(newData);
    }
  }

  const haveAtLeastOnEventAllocated = (props) => {
    const { id } = props.original;
    const foundBooking = data.find((el) => el.id === id);
    if (foundBooking) {
      if (foundBooking.multiple_date) {
        const events = data.filter((el) => el.id === id);
        if (events && events.length > 0) {
          let result = false;
          for (let i = 0; i < events.length && !result; i++) {
            if (
              events[i].teacher &&
              events[i].status != teacherStatus.not_assigned
            ) {
              result = true;
            }
          }
          return result;
        } else {
          return foundBooking.status === teacherStatus.not_assigned
            ? false
            : true;
        }
      } else {
        return foundBooking.status === teacherStatus.not_assigned
          ? false
          : true;
      }
    }
  };

  const buildUpdateLevel = (props) => {
    const foundBooking = data.find((el) => el.id === props.original.id);
    const levels = allClass.find((c) => c.class_id === foundBooking.class_id)?.level

    return <div>
      <FormDropdown onChange={(e) => setUpdatedLevel(e.target.value)}>
        <option value="">
          Select class level
        </option>
        {levels && levels.map((level) =>
          <option value={level}>
            {getClass().find(c => c.key === level).whole_name}
          </option>)}
      </FormDropdown>

      <button
        className="btn btn-primary btn-sm"
        onClick={() => updateLevel(props, updatedLevel)}
      >
        Update
      </button>
    </div>
  }

  const updateLevel = (props, level) => {
    if (level) {
      let newData = [...data];
      API.updateBookingLevel(props.original.id, level).then((result) => {
        setUpdatedLevel("")
        const foundBooking = newData.find((el) => el.id === props.original.id);
        if (foundBooking) {
          // console.log(foundBooking)
          foundBooking.level = getClass().find(c => c.key === level).whole_name
        }
        setData(newData);
        notify.show("Level updated successfully")
      }).catch((err) => {
        console.log(err);
      });
    } else {
      notify.show("Please select a valid level")
    }
  }

  const buildSplitCheckboxes = (props) => {
    const atLeastAllocated = haveAtLeastOnEventAllocated(props);
    const foundBooking = data.find((el) => el.id === props.original.id);
    const { original } = props;

    return props.original.split_index === 0 ? (
      <div
        style={
          atLeastAllocated || !foundBooking.multiple_date
            ? { pointerEvents: "none" }
            : null
        }
      >
        {/* <input
          type="radio"
          value="no_split"
          checked={
            eventSplitTypes[props.original.id] === EventSplitType.NoSplit
          }
          onChange={(evt) =>
            splitCheckBoxesValueChanged(props.original.id, props.index, evt)
          }
        />{" "}
        No split */}
        
        {
          original.multiple_date &&
          original.all_dates &&
          original.all_dates.length &&
          (!atLeastAllocated || (currentResplitBooking[original.id]?.isEdit)) && (
            <React.Fragment>
              Split
              <input className="mx-2 px-2" type="number" 
              defaultValue={!!currentSplitEventByBooking?.[original.id] ? currentSplitEventByBooking?.[original.id] : original.splits.length} 
              name="split_to" 
              min="1"
              max={original.all_dates.length} 
              style={
                {width: "30px", border: "1px solid black"}
              }
              onChange={(evt) =>
                splitBookingValueChange(
                  props.original.id,
                  props.index,
                  evt
                )
              }
              />
            </React.Fragment>
          )
        }
        
        {/* {original.multiple_date &&
          original.all_dates &&
          original.all_dates.length > 1 && (
            <>
              <input
                className="ml-3"
                type="radio"
                value="split_2_events"
                checked={
                  eventSplitTypes[props.original.id] ===
                  EventSplitType.SplitInto2Events
                }
                onChange={(evt) =>
                  splitCheckBoxesValueChanged(
                    props.original.id,
                    props.index,
                    evt
                  )
                }
              />{" "}
              Split into 2 events
            </>
          )}
        {original.multiple_date &&
          original.all_dates &&
          original.all_dates.length > 2 && (
            <>
              <input
                className="ml-3"
                type="radio"
                value="split_3_events"
                checked={
                  eventSplitTypes[props.original.id] ===
                  EventSplitType.SplitInto3Events
                }
                onChange={(evt) =>
                  splitCheckBoxesValueChanged(
                    props.original.id,
                    props.index,
                    evt
                  )
                }
              />{" "}
              Split into 3 events
            </>
          )} */}
      </div>
    ) : null;
  };

  const validateSplitDate = (booking, splitDate) => {
    const foundDate = booking.all_dates.find((el) => el.date === splitDate);
    return foundDate ? true : false;
  };

  const validateSplitDateOverlap = (split1, split2) => {
    let split1FromTime = new Date(split1.split_start_date).getTime();
    let split1ToTime = new Date(split1.split_end_date).getTime();

    if (split1FromTime > split1ToTime) {
      return true;
    }

    let split2FromTime = new Date(split2.split_start_date).getTime();
    let split2ToTime = new Date(split2.split_end_date).getTime();

    if (split2FromTime > split2ToTime) {
      return true;
    }

    return (
      Math.max(split1FromTime, split2FromTime) <=
      Math.min(split1ToTime, split2ToTime)
    );
  };

  const validateBookingInformation = (props) => {
    let result = true;

    const { id, split_index } = props.original;
    const oriBooking = data.find((el) => el.id === id);
    const subEvent = data.find(
      (el) => el.id === id && el.split_index === split_index
    );
    if (oriBooking) {
      if (!subEvent.teacher) {
        result = false;
        notify.show("You must to assign a teacher before submitting.", "error");
      } else {
        if (currentSplitEventByBooking[id] > 1) {
          const allEvents = data.filter((el) => el.id === id);
          for (let i = 0; i < allEvents.length && result; i++) {
            const currentSplit = allEvents[i];

            // const isFromValid = validateSplitDate(
            //   oriBooking,
            //   currentSplit.split_start_date
            // )

            const isFromValid = currentSplit.split_start_date != "error";

            if (!isFromValid) {
              result = false;
              notify.show("The split from date does not valid.", "error");
            } else {
              // const isToValid = validateSplitDate(
              //   oriBooking,
              //   currentSplit.split_end_date
              // )

              const isToValid = currentSplit.split_end_date != "error";

              if (!isToValid) {
                result = false;
                notify.show("The split to date does not valid.", "error");
              } else {
                if (
                  currentSplit.split_start_date > currentSplit.split_end_date
                ) {
                  result = false;
                  notify.show(
                    "The current split' end date is before start date"
                  );
                } else {
                  for (let i = 0; i < allEvents.length && result; i++) {
                    for (let j = i + 1; j < allEvents.length && result; j++) {
                      const overlapped = validateSplitDateOverlap(
                        allEvents[i],
                        allEvents[j]
                      );

                      if (overlapped) {
                        result = false;
                        notify.show(
                          "The split dates in the whole booking are not valid, there is an overlap among splits",
                          "error"
                        );
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      result = false;
      notify.show("Cannot find booking info for the current id", "error");
    }

    return result;
  };

  const assignTeacherForSingleBooking = (
    booking_id,
    split_index,
    teacher_id,
    previous_teacher_id
  ) => {
    try {
      API.assignTeacherToBooking("/assignTeacherToBooking", {
        teacher_id: teacher_id,
        booking_id: booking_id,
        previous_teacher_allocation: previous_teacher_id,
      })
      .then(function (result) {
        notify.show("Sucessfully assigned a teacher.");
        updateTeacherAssignedStatus(booking_id, split_index);
      })
      .catch(function (err) {
        notify.show("Failed to assign a teacher.", "error");
      });

      // axios({
      //   method: "post",
      //   url: `${PORT}/assignTeacherToBooking`,
      //   data: {
      //     teacher_id: teacher_id,
      //     booking_id: booking_id,
      //     previous_teacher_allocation: previous_teacher_id,
      //   },
      // })
      //   .then(function (result) {
      //     notify.show("Sucessfully assigned a teacher.");
      //     updateTeacherAssignedStatus(booking_id, split_index);
      //   })
      //   .catch(function (err) {
      //     notify.show("Failed to assign a teacher.", "error");
      //   });
    } catch (error) {
      notify.show(error, "error");
    }
  };

  const assignTeacherForMultipleDaysBooking = (
    booking_id,
    updated_splits,
    teacher_id,
    split_index,
    dates,
    updatedBooking
  ) => {
    try {
      API.assignTeacherToBooking("/assignTeacherToMultipleDayBooking", {
        updated_splits: updated_splits,
        teacher_id: teacher_id,
        booking_id: booking_id,
        dates: dates,
        updated_booking: updatedBooking
      }).then(function (result) {
        notify.show("Sucessfully assigned a teacher.");
        updateTeacherAssignedStatus(booking_id, split_index);
      })
      .catch(function (err) {
        notify.show("Failed to assign a teacher.", "error");
      });

      // axios({
      //   method: "post",
      //   url: `${PORT}/assignTeacherToMultipleDayBooking`,
      //   data: {
      //     updated_splits: updated_splits,
      //     teacher_id: teacher_id,
      //     booking_id: booking_id,
      //     dates: dates,
      //     updated_booking: updatedBooking
      //   },
      // })
        
    } catch (error) {
      notify.show(error, "error");
    }
  };

  const updateLastAllocation = (oriBooking, split_index, newTeacherId) => {
    try {
    const instId = queryInstitutionId(oriBooking.campus_id);
      const bookingList = bookingDict[instId] || null;
      if (bookingList) {
        const booking = bookingList.find((el) => el._id === oriBooking.id);
        if (oriBooking.multiple_date) {
          if (split_index < booking.splits.length) {
            booking.splits[split_index].teacher_id = newTeacherId;
          } else {
            const newEventCount = split_index - booking.splits.length;
            for (let i = 0; i < newEventCount; i++) {
              booking.splits.push({ teacher_id: null });
            }
            if (booking.splits.length > 0) {
              booking.splits[0].teacher_id = newTeacherId;
            }
          }
        } else {
          booking.teacher_id = newTeacherId;
        }
      }
    } catch(error) {
      console.log("FOUND ERR on updateLastAllocation: ", error)
    }
  };

  const updateTeacherAssignedStatus = (id, split_index) => {
    const newData = [...data];
    const oriBooking = newData.find((el) => el.id === id);
    const foundEvent = newData.find(
      (el) => el.id === id && el.split_index === split_index
    );

    if (foundEvent) {
      updateLastAllocation(oriBooking, split_index, foundEvent.teacher._id);

      foundEvent.status = teacherStatus.assigned;
      foundEvent.teacher_status = teacherStatus.assigned;
      foundEvent.teacher_response = teacherResponse.not_responded;
      foundEvent.payment_status = "";
    }

    let currentTime = new Date(oriBooking.end_date).getTime();
    const tobeUpdatedBookings = newData.filter((el) => {
      let comparedTime = new Date(el.end_date).getTime();
      return comparedTime > currentTime;
    });
    tobeUpdatedBookings.forEach(
      (booking) =>
        (booking.last_allocate = getLastBookingTeacherAllocation(
          booking.campus_id,
          booking.end_date
        ))
    );

    setData(newData);
  };

  const prepareDataForSubmitting = (props) => {
    const { id, split_index, all_dates, previous_teacher_allocation } =
      props.original;
    const foundBooking = data.find(
      (el) => el.id === id && el.split_index === split_index
    );
    let updatedBooking = null;
    if (foundBooking) {
      // Get all event information of current booking
      const splits = [];
      let newDates = [];
      const events = data.filter((el) => el.id === id);
      if (events) {
        events.forEach((event, index) => {
          const info = {
            date_from: event.split_start_date || "",
            date_to: event.split_end_date || "",
            teacher_id: event.teacher ? event.teacher._id : null,
            teacher_response:
              index === split_index
                ? teacherResponse.not_responded
                : event.teacher_response || teacherResponse.not_responded,
            teacher_status:
              index === split_index
                ? teacherStatus.assigned
                : event.teacher_status || teacherStatus.not_assigned,
            payment_status: event.payment_status || "",
            previous_teacher_allocation: previous_teacher_allocation,
          };
          if (event.status === "cancelled by inst") {
            info.cancelled_by_inst = true;
            info.cancelled_by = event.cancelled_by;
            info.cancelled_time = event.cancelled_time;
            info.inst_cancelled_reason = event.inst_cancel_reason;
          }
          splits.push(info);
          if(index === split_index) {
            updatedBooking = info
          }
        });

        newDates = all_dates.map((dateObj) => {
          if (
            dateObj.date >= foundBooking.split_start_date &&
            dateObj.date <= foundBooking.split_end_date
          ) {
            // console.log(dateObj.date)
            dateObj.teacher_id = foundBooking.teacher._id;
            dateObj.teacher_status = teacherStatus.assigned;
            dateObj.teacher_response = teacherResponse.not_responded;
            dateObj.previous_teacher_allocation = previous_teacher_allocation;
            if(!dateObj.cancelled_by_inst) {
              delete dateObj.cancelled_time
              delete dateObj.teacher_cancel_reason
            } 
          }
          return dateObj;
        });
      }

      return {
        booking_id: id,
        updated_splits: splits,
        teacher_id: foundBooking.teacher._id,
        dates: newDates,
        updatedBooking
      };
    } else {
      return null;
    }
  };

  const onEventSubmitClicked = (props) => {
    const isDataValid = validateBookingInformation(props);
    if (isDataValid) {
      const { id, split_index, previous_teacher_allocation } = props.original;
      const foundBooking = data.find((el) => el.id === id);
      if (!foundBooking.multiple_date) {
        const event = data.find(
          (el) => el.id === id && el.split_index === split_index
        );
        assignTeacherForSingleBooking(
          id,
          split_index,
          event.teacher._id,
          previous_teacher_allocation
        );
      } else {
        const updatedInfo = prepareDataForSubmitting(props);
        if (updatedInfo) {
          const { booking_id, updated_splits, teacher_id, dates, updatedBooking } = updatedInfo;
          assignTeacherForMultipleDaysBooking(
            booking_id,
            updated_splits,
            teacher_id,
            split_index,
            dates,
            updatedBooking
          );
        }
      }
      toggleConfirm(props, false);
    }
  };

  const onReassignClicked = (props) => {
    const { id, split_index, teacher, multiple_date } = props.original;
    let newData = data.map((item) => {
      if (item.id === id && item.split_index === split_index) {
        item.teacher = null;
        item.teachername = "";
        item.status = teacherStatus.not_assigned;
        item.teacher_status = teacherStatus.not_assigned;
        item.teacher_response = teacherResponse.not_responded;
        item.previous_teacher_allocation = teacher._id;
        setCurrentSplitEventByBooking({
          ...currentSplitEventByBooking,
          [item.id]: item.splits.length
        })
      }
      return item;
    });
    if (!multiple_date) {
      API.deallocateSingle(id);
    }

    if (multiple_date && split_index !== null && split_index !== undefined && +split_index >= 0) {
      API.deallocateSplit(id, split_index);
    }

    setData(newData);
    toggleConfirm(props, false);
  };

  const hasAllocatedStatusForCurrentEvent = (original) => {
    const { id, split_index } = original;
    const oriBooking = data.find((el) => el.id === id);
    if (oriBooking) {
      if (oriBooking.multiple_date) {
        const event = data.find(
          (el) => el.id === id && el.split_index === split_index
        );
        if (event) {
          return event.status === teacherStatus.not_assigned || event.status === teacherStatus.none_available
            ? false
            : event.teacher_response != teacherResponse.rejected;
        }
      } else {
        return !(oriBooking.status === teacherStatus.not_assigned || oriBooking.status === teacherStatus.none_available);
      }
    }
  };

  const hasCancelledByInst = (original) => {
    const { id, split_index } = original;
    
    const oriBooking = data.find((el) => el.id === id);
    if (oriBooking) {
      if (oriBooking.multiple_date) {
        const event = data.find(
          (el) => el.id === id && el.split_index === split_index
        );
        return event?.status === "cancelled by inst"
      } else {
        return oriBooking.status === "cancelled by inst"
      }
    }
  };

  const checkBookingNoneAvailable = (original) => {
    const { id, split_index } = original;
    
    const oriBooking = data.find((el) => el.id === id);
    if (oriBooking) {
      if(oriBooking.isConfirm) return false
      if (oriBooking.multiple_date) {
        const event = data.find(
          (el) => el.id === id && el.split_index === split_index
        );
        if(event.isConfirm) return false
        else return event?.unavailable_teacher
      } else {
        if(oriBooking.isConfirm) return false
        else return oriBooking?.unavailable_teacher
      }
    }
  }

  const checkAvailability = (original) => {
    const { id, split_index } = original;
    const oriBooking = data.find((el) => el.id === id && el.split_index === split_index);
    if (oriBooking) {
      // console.log(oriBooking)
      return oriBooking.unavailable_teacher || oriBooking.status === teacherStatus.none_available
    }
  };

  const prepareDataForConfirmingUnavailable = (props) => {
    const { id, split_index, all_dates, previous_teacher_allocation } =
      props.original;
    const foundBooking = data.find(
      (el) => el.id === id && el.split_index === split_index
    );
    if (foundBooking) {
      const splits = [];
      let newDates = [];
      const events = data.filter((el) => el.id === id);
      if (events) {
        events.forEach((event, index) => {
          // console.log(event)
          const info = {
            date_from: event.split_start_date || "",
            date_to: event.split_end_date || "",
            teacher_id: event.teacher ? event.teacher._id : null,
            teacher_response:
              index === split_index
                ? teacherResponse.not_responded
                : event.teacher_response || teacherResponse.not_responded,
            teacher_status:
              index === split_index
                ? teacherStatus.none_available
                : event.teacher_status || teacherStatus.not_assigned,
            payment_status: event.payment_status || "",
            previous_teacher_allocation: previous_teacher_allocation,
            unavailable_teacher: index === split_index ? true : event.unavailable_teacher || false
          };
          splits.push(info);
        });

        newDates = all_dates.map((dateObj) => {
          if (
            dateObj.date >= foundBooking.split_start_date &&
            dateObj.date <= foundBooking.split_end_date
          ) {
            dateObj.teacher_id = foundBooking.teacher_id ? foundBooking.teacher_id : null;
            dateObj.teacher_status = teacherStatus.none_available
            dateObj.teacher_response = teacherResponse.not_responded;
            dateObj.previous_teacher_allocation = previous_teacher_allocation;
            dateObj.unavailable_teacher = true
          }
          return dateObj;
        });
      }

      return {
        booking_id: id,
        updated_splits: splits,
        dates: newDates,
      };
    } else {
      return null;
    }
  };

  const confirmUnavailable = (props) => {
    const {id, split_index} = props.original;
    const foundBooking = data.find((el) => el.id === id);
    let newData = data.map((item) => {
      if (item.id === id && item.split_index === split_index) {
        // console.log(item)
        item.status = teacherStatus.none_available;
        item.teacher_status = teacherStatus.none_available;
        item.unavailable_teacher = true
      }
      return item;
    });
    if (!foundBooking.multiple_date) {
      API.markUnAvailableForBooking(id)
        .then(res => {
          notify.show("Set no availability to the booking.")
        })
        .catch(err => {
          console.log(err.response)
        })
    } else {
      const updatedInfo = prepareDataForConfirmingUnavailable(props);
      // console.log(updatedInfo)
      if (updatedInfo) {
        const {booking_id, updated_splits, dates} = updatedInfo;
        API.markUnAvailableForBooking(booking_id, updated_splits, dates, props.original.split_index)
          .then(res => {
            notify.show("Set no availability to the booking.")
          })
          .catch(err => {
            console.log(err.response)
          })
      }
    }
    setData(newData);
  }

  const buildEventSubmitButton = (props) => {
    const allocated = hasAllocatedStatusForCurrentEvent(props.original);
    const isConfirm = props.original.isConfirm;
    const cancelledByInst = hasCancelledByInst(props.original)
    return  !cancelledByInst ? ( 
      isConfirm ? (
        !allocated ? (
          <>
            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={() => onEventSubmitClicked(props)}
            >
              Submit
            </button>
            <br />
            <button
              type="button"
              className="btn secondary-button-no-margin-hover btn-sm"
              onClick={() => toggleConfirm(props, false)}
            >
              Cancel
            </button>
          </>
        ) : (
          <>
            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={() => onReassignClicked(props)}
            >
              Clean assigned
            </button>
            <br />
            <button
              type="button"
              className="btn secondary-button-no-margin-hover btn-sm"
              onClick={() => toggleConfirm(props, false)}
            >
              Cancel
            </button>
          </>
        )
      ) : (
        <>
          <button
            type="button"
            className="btn btn-primary btn-sm mb-2 d-block"
            onClick={() => toggleConfirm(props, true)}
          >
            {allocated ? "Reassign" : "Assign"}
          </button>
          <button
            type="button"
            disabled={checkAvailability(props.original)}
            className={allocated ? "d-none" : "btn btn-primary btn-sm d-block"}
            onClick={() => confirmUnavailable(props)}
          >
            None Available
          </button>
        </>
      )
    ) : null
  };

  const toggleConfirm = (props, isConfirm) => {
    const { id, split_index } = props.original;
    const newData = data.map((item) => {
      if (item.id === id && item.split_index === split_index) {
        item.isConfirm = isConfirm;
      }
      return item;
    });
    setData(newData);
  };

  const handleTestBookingsDisplayChanges = () => {
    if (showTestBookings) {
      window.location.reload()
    } else {
      setData([...data, ...testBookingDatalist])
    }
  }

  return (
    <AdminWrapper>
      {/* Menu area */}
      <SwitchMenuBar isViewAsTeacher />
      <div className="container-wrapper-JobList">
        <div className="linear-gradient-JobList">
          {/* Body area */}
          <div className="body-main-page-JobList">
            <div className="d-flex justify-start ml-20 ">
              <p className="text-3xl font-bold flex flex-col justify-center ml-10">
                All bookings
              </p>
            </div>

            <div className="d-flex flex-row overflow-auto collapse-check-buttons">
              <CheckableButton
                noBorder
                checked={showCreatedTime}
                onClick={() => setShowCreatedTime((s) => !s)}
                onChange={(e) => setShowCreatedTime(e.target.checked)}
              >
                Created Time
              </CheckableButton>
              <CheckableButton
                noBorder
                checked={showArrival}
                onClick={() => setShowArrival((s) => !s)}
                onChange={(e) => setShowArrival(e.target.checked)}
              >
                Arrival
              </CheckableButton>
              <CheckableButton
                noBorder
                checked={showUpdateLevel}
                onClick={() => setShowUpdateLevel((s) => !s)}
                onChange={(e) => setShowUpdateLevel(e.target.checked)}
              >
                Update Level
              </CheckableButton>
              <CheckableButton
                noBorder
                checked={showCampus}
                onClick={() => setShowCampus((s) => !s)}
                onChange={(e) => setShowCampus(e.target.checked)}
              >
                Campus
              </CheckableButton>
              <CheckableButton
                noBorder
                checked={showTeachingHours}
                onClick={() => setShowTeachingHours((s) => !s)}
                onChange={(e) => setShowTeachingHours(e.target.checked)}
              >
                T hrs/day
              </CheckableButton>
              <CheckableButton
                noBorder
                checked={showNonTeachingHours}
                onClick={() => setShowNonTeachingHours((s) => !s)}
                onChange={(e) => setShowNonTeachingHours(e.target.checked)}
              >
                NT
              </CheckableButton>
              <CheckableButton
                noBorder
                checked={showLastTeacher}
                onClick={() => setShowLastTeacher((s) => !s)}
                onChange={(e) => setShowLastTeacher(e.target.checked)}
              >
                Last Teacher
              </CheckableButton>
              <CheckableButton
                noBorder
                checked={showFav}
                onClick={() => setShowFav((s) => !s)}
                onChange={(e) => setShowFav(e.target.checked)}
              >
                Show Fav
              </CheckableButton>
              <CheckableButton
                noBorder
                checked={showAvail}
                onClick={() => setShowAvail((s) => !s)}
                onChange={(e) => setShowAvail(e.target.checked)}
              >
                Show Avail
              </CheckableButton>
              <CheckableButton
                noBorder
                checked={show25kms}
                onClick={() => setShow25kms((s) => !s)}
                onChange={(e) => setShow25kms(e.target.checked)}
              >
                Show 25kms
              </CheckableButton>
              <CheckableButton
                noBorder
                checked={showTestBookings}
                onClick={() => {
                  setShowTestBookings((s) => !s);
                  handleTestBookingsDisplayChanges()}
                }
                // onChange={handleTestBookingsDisplayChanges}
              >
                Show Test Bookings
              </CheckableButton>
            </div>

            <ReactTable
              data={data}
              columns={[
                // {
                //   Header: "ID",
                //   accessor: "id",
                //   width: 75,
                //   Cell: (props) => {
                //     return props.original.id
                //   },
                //   filterable: false,
                // },
                {
                  Header: "Created",
                  accessor: "created",
                  Cell: (props) =>
                    !props.original.is_subjob &&
                    !!props.original.created && (
                      <Moment 
                        tz="Australia/Melbourne"
                        parse="YYYY-MM-DD HH:mm:ss" 
                        format="DD/MM/YYYY">
                        {props.original.created}
                      </Moment>
                    ),
                  sortMethod: (a, b, desc) => {
                    let mapDate = (date) => {
                      let arr = date.split(" ")[0].split("-");
                      // console.log(arr)
                      return `${arr[0]}-${arr[1].padStart(
                        2,
                        "0"
                      )}-${arr[2].padStart(2, "0")}`;
                    };
                    let dateA = a ? mapDate(a) : "";
                    let dateB = b ? mapDate(b) : "";
                    if (dateA > dateB) return 1;
                    else if (dateA < dateB) return -1;
                    else return 0;
                  },
                  defaultSortDesc: true,
                  filterable: true,
                  Filter: (props) => {
                    let value = props.filter && props.filter.value;
                    // console.log(value)
                    return (
                      <FormDatePicker
                        placeholderText="Select date"
                        selected={value ? new Date(props.filter.value) : null}
                        onChange={props.onChange}
                        isClearable
                        dateFormat="dd/MM/yyyy"
                        className="datepicker-2"
                      />
                    );
                  },
                  filterMethod: (filter, row, column) => {
                    const id = filter.pivotId || filter.id;
                    const selectedDate = filter.value
                      ? new Date(
                          filter.value -
                            filter.value.getTimezoneOffset() * 1000 * 60
                        )
                          .toISOString()
                          .slice(0, 10)
                      : "";
                    let mapDate = (date) => {
                      if (date === undefined) {
                        return;
                      }
                      const selectedDate = new Date(date);
                      // Get the date in ISO format (YYYY-MM-DD)
                     const isoDateString = moment(selectedDate).format('YYYY-MM-DD');
                      return isoDateString;
                    };
                    let compareDate = mapDate(row[id]);
                    return selectedDate
                      ? String(compareDate) === selectedDate
                      : true;
                  },
                },
                {
                  Header: "Created Time",
                  accessor: "created_time",
                  width: 75,
                  show: showCreatedTime,
                  Cell: (props) =>
                    !props.original.is_subjob &&
                    !!props.original.created && (
                      <Moment
                        tz="Australia/Melbourne"
                        parse="YYYY-MM-DD HH:mm:ss"
                        format="HH:mm:ss"
                      >
                        {moment.utc(props.original.created)}
                      </Moment>
                    ),
                },
                {
                  Header: "Start Date",
                  accessor: "start_date",
                  // sortMethod: (a, b) => {
                  //   console.log(a, b)
                  //   if (a > b) return 1;
                  //   if (a < b) return -1;
                  // },
                  Cell: (props) =>
                    !props.original.is_subjob && props.original.start_date_au,
                  defaultSortDesc: true,
                  filterable: true,
                  Filter: (props) => {
                    let value = props.filter && props.filter.value;
                    // console.log(value)
                    return (
                      <FormDatePicker
                        placeholderText="Select date"
                        selected={value ? new Date(props.filter.value) : null}
                        onChange={props.onChange}
                        isClearable
                        dateFormat="dd/MM/yyyy"
                        className="datepicker-2"
                      />
                    );
                  },
                  filterMethod: (filter, row, column) => {
                    const id = filter.pivotId || filter.id;
                    const selectedDate = filter.value
                      ? new Date(
                          filter.value -
                            filter.value.getTimezoneOffset() * 1000 * 60
                        )
                          .toISOString()
                          .slice(0, 10)
                      : "";

                    let shouldShow = selectedDate
                    ? (row[id] !== undefined && row[id] !== "0/0/0")
                      ? String(row[id]) === selectedDate 
                      : false
                    : true
                    
                    shouldShow = !shouldShow && row['_original'][`filter_${id}`]
                      ? new Date(row['_original'][`filter_${id}`])?.toISOString().slice(0, 10) == selectedDate
                      : shouldShow
                    
                    return shouldShow
                  },
                },
                {
                  Header: "End Date",
                  accessor: "end_date",
                  Cell: (props) =>
                    !props.original.is_subjob &&
                    // props.original.end_date_au !== "0/0/0" &&
                    props.original.end_date_au,
                  defaultSortDesc: true,
                  filterable: true,
                  Filter: (props) => {
                    let value = props.filter && props.filter.value;
                    // console.log(value)
                    return (
                      <FormDatePicker
                        placeholderText="Select date"
                        selected={value ? new Date(props.filter.value) : null}
                        onChange={props.onChange}
                        isClearable
                        dateFormat="dd/MM/yyyy"
                        className="datepicker-2"
                      />
                    );
                  },
                  filterMethod: (filter, row, column) => {
                    const id = filter.pivotId || filter.id;
                    const selectedDate = filter.value
                      ? new Date(
                          filter.value -
                            filter.value.getTimezoneOffset() * 1000 * 60
                        )
                          .toISOString()
                          .slice(0, 10)
                      : "";

                    let shouldShow = selectedDate
                    ? (row[id] !== undefined && row[id] !== "0/0/0")
                      ? String(row[id]) === selectedDate 
                      : false
                    : true
                    
                    shouldShow = !shouldShow && row['_original'][`filter_${id}`]
                      ? new Date(row['_original'][`filter_${id}`])?.toISOString().slice(0, 10) == selectedDate
                      : shouldShow
                    
                    return shouldShow
                  },
                },
                {
                  Header: "Arrival ",
                  accessor: "arrival",
                  width: 75,
                  show: showArrival,
                  Cell: (props) =>
                    !props.original.is_subjob && props.original.arrival,
                  filterable: true,
                },
                {
                  Header: "Start",
                  accessor: "start",
                  width: 75,
                  Cell: (props) =>
                    !props.original.is_subjob && props.original.start,
                  filterable: true,
                },
                {
                  Header: "End",
                  accessor: "end",
                  width: 75,
                  Cell: (props) =>
                    !props.original.is_subjob && props.original.end,
                  filterable: true,
                },
                {
                  Header: "Days",
                  accessor: "days_of_delivery",
                  width: 75,
                  Cell: (props) => {
                    return props.original.is_subjob
                    ? ""
                    : props.original.days_of_delivery
                        ?.map((day) => day.substr(0, 2))
                        ?.join(", ")
                  },
                  filterable: true,
                },
                {
                  Header: "Level/Type",
                  accessor: "level",
                  width: 120,
                  Cell: (props) =>
                    !props.original.is_subjob && props.original.level,
                  filterable: true,
                },
                {
                  Header: "Update Level",
                  width: 140,
                  show: showUpdateLevel,
                  Cell: (props) => !props.original.is_subjob && buildUpdateLevel(props)
                },
                {
                  Header: "Mode",
                  accessor: "deliveryMode",
                  width: 90,
                  Cell: (props) =>
                    !props.original.is_subjob && props.original.deliveryMode,
                  filterable: true,
                },
                {
                  Header: "Inst.",
                  accessor: "institution",
                  width: 120,
                  Cell: (props) =>
                    !props.original.is_subjob && props.original.institution,
                  filterable: true,
                },
                {
                  Header: "Campus",
                  accessor: "campus_city",
                  show: showCampus,
                  width: 100,
                  Cell: (props) =>
                    !props.original.is_subjob && props.original.campus_city,
                  filterable: true,
                },
                {
                  Header: "Maker",
                  accessor: "makername",
                  width: 90,
                  Cell: (props) =>
                    !props.original.is_subjob && props.original.makername,
                  filterable: true,
                },
                {
                  Header: "T hrs/day",
                  accessor: "teaching_hour",
                  show: showTeachingHours,
                  Cell: (props) =>
                    !props.original.is_subjob && props.original.teaching_hour,
                  filterable: true,
                  width: 60,
                },
                {
                  Header: "Total T hrs",
                  accessor: "total_teaching_hour",
                  Cell: (props) =>
                    !props.original.is_subjob && props.original.total_teaching_hour,
                  filterable: true,
                  width: 60,
                },
                {
                  Header: "NT",
                  accessor: "non_teaching_mins",
                  show: showNonTeachingHours,
                  Cell: (props) =>
                    !props.original.is_subjob &&
                    props.original.non_teaching_mins,
                  filterable: true,
                  width: 60,
                },
                {
                  Header: "Last T",
                  accessor: "last_allocate",
                  show: showLastTeacher,
                  minWidth: 90,
                  Cell: (props) =>
                    !props.original.is_subjob && props.original.last_allocate,
                  filterable: true,
                },
                {
                  Header: "Preferred T",
                  accessor: "pref_tea_name",
                  width: 90,
                  filterable: true,
                },
                {
                  Header: "No. of Events (Lessons)",
                  accessor: "lessons",
                  style: { whiteSpace: "unset" },
                  width: 60,
                  Cell: (props) =>
                    !props.original.is_subjob && props.original.lessons,
                  filterable: true,
                },
                {
                  Header: "Split Booking",
                  Cell: (props) => buildSplitCheckboxes(props),
                  width: 90,
                },
                {
                  Header: "Split dates selection",
                  Cell: (props) => dateRangeCell(props),
                  width: 150,
                },
                {
                  Header: "Show fav",
                  accessor: "check_fav",
                  show: showFav,
                  width: 60,
                  Cell: (props) => checkboxCell(props),
                  getProps: () => ({
                    func: flipfilter,
                    label: "check_fav",
                  }),
                },
                {
                  Header: "Teachers",
                  width: 135,
                  Cell: (props) => dropdownCell(props),
                },
                {
                  Header: "Show Avail",
                  accessor: "check_ava",
                  width: 60,
                  show: showAvail,
                  Cell: (props) => checkboxCell(props),
                  getProps: () => ({
                    func: flipfilter,
                    label: "check_ava",
                  }),
                },
                {
                  Header: "Show 25kms",
                  accessor: "check_25km",
                  width: 60,
                  show: show25kms,
                  Cell: (props) => checkboxCell(props),
                  getProps: () => ({
                    func: flipfilter,
                    label: "check_25km",
                  }),
                },
                {
                  Header: "Allocation",
                  accessor: "teachername",
                  width: 120,
                  filterable: true,
                },
                {
                  Header: "Submit",
                  width: 110,
                  Cell: (props) => buildEventSubmitButton(props),
                },
                {
                  Header: "Status",
                  accessor: "status",
                  filterable: true,
                  Filter: (props) => (
                    <select
                      className="w-100"
                      onChange={(event) => props.onChange(event.target.value)}
                    >
                      <option value="">all</option>
                      <option>{teacherStatus.not_assigned}</option>
                      <option>{teacherStatus.assigned}</option>
                      <option>{teacherStatus.none_available}</option>
                      <option>{teacherResponse.accepted}</option>
                      <option>{teacherResponse.rejected}</option>
                      <option>{teacherResponse.cancelled}</option>
                      <option>cancelled by inst</option>
                    </select>
                  ),
                  filterMethod: (filter, row, column) => {
                    const id = filter.pivotId || filter.id;
                    return row[id] !== undefined
                      ? String(row[id]).toLowerCase() ===
                          filter.value.toLowerCase()
                      : true;
                  },
                  // width: 150,
                },
                {
                  Header: "Reason for Cancellation",
                  accessor: "teacher_cancel_reason",
                  // width: 200,
                  Cell: (props) => {
                    if (props.original.teacher_cancel_reason) {
                      let reason =
                        cancellationReasons.find(
                          (r) =>
                            r.value === props.original.teacher_cancel_reason
                        ) || {};
                      return reason.description;
                    } else if (props.original.inst_cancel_reason) {
                      return props.original.inst_cancel_reason
                    }
                  },
                  filterable: true,
                  Filter: (props) => (
                    <select
                      onChange={(event) => props.onChange(event.target.value)}
                      style={{ width: "200px" }}
                    >
                      <option value="">all</option>
                      {cancellationReasons.map((reason) => {
                        return (
                          <option value={reason.value}>
                            {reason.description}
                          </option>
                        );
                      })}
                    </select>
                  ),
                  filterMethod: (filter, row, column) => {
                    const id = filter.pivotId || filter.id;
                    console.log(row[id], filter.value);
                    return row[id] !== undefined
                      ? String(row[id]).toLowerCase() ===
                          filter.value.toLowerCase()
                      : true;
                  },
                  width: 200,
                },
                {
                  Header: "Canceled Time",
                  accessor: "cancelled_time",
                  Cell: (props) => {
                    return props.original.cancelled_time ? <Moment tz="Australia/Melbourne" parse="YYYY-MM-DD HH:mm:ss" format="DD/MM/YYYY HH:mm:ss">
                              {moment.utc(props.original.cancelled_time)}
                          </Moment> : null
                  },
                  filterable: false,
                  width: 200,
                },
                {
                  Header: "Canceled By",
                  accessor: "cancelled_by",
                  Cell: (props) => {
                    return props.original.cancelled_by
                  },
                  filterable: false,
                  width: 200,
                },
                {
                  Header: "Last Status",
                  accessor: "last_status_before_cancel",
                  Cell: (props) => {
                    return props.original.last_status_before_cancel
                  },
                  filterable: false,
                  width: 200,
                }
              ]}
              defaultPageSize={10}
              className="-striped -highlight"
              // defaultSortMethod={(a, b, desc) => {
              //   // force null and undefined to the bottom
              //   a = a || "";
              //   b = b || "";
              //   // force any string values to lowercase
              //   a = typeof a === 'string' ? a.toLowerCase() : a;
              //   b = typeof b === 'string' ? b.toLowerCase() : b;
              //   // Return either 1 or -1 to indicate a sort priority
              //   if (a > b) {
              //     return 1
              //   }
              //   if (a < b) {
              //     return -1
              //   }
              //   // returning 0 or undefined will use any subsequent column sorting methods or the row index as a tiebreaker
              //   return 0
              // }}
              defaultFilterMethod={(filter, row, column) => {
                const id = filter.pivotId || filter.id;
                let shouldShow = row[id] !== undefined
                  ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase())
                  : false
                shouldShow = shouldShow || String(row['_original'][`filter_${id}`]).toLowerCase().includes(filter.value.toLowerCase())
                return shouldShow
              }}
              // column={{
              //   ...ReactTableDefaults.column,
              //   Cell: (props) => <div style={{ overflow: "auto", color: "blue" }}>{props.children}</div>
              // }}
            />
          </div>
        </div>
      </div>
    </AdminWrapper>
  );
};

export default AllocationTablePage;
